import React from "react";

import { SharedSaveProps } from "../types";
import { SaveToBuyerList } from "./SaveToBuyerList";
import { SaveToCompetitorOrPartner } from "./SaveToCompetitorOrPartner";
import { SaveToNoticeList } from "./SaveToNoticeList";

export function SaveToLists({
  entityType,
  entityIds,
  creation,
  setCreation,
}: SharedSaveProps & {
  creation: boolean;
  setCreation: (creation: boolean) => void;
}) {
  switch (entityType) {
    case "notice":
      // TODO: When we allow saving multiple notices to
      // a single list we will need to move lists over to `entityIds`
      return (
        <SaveToNoticeList entityId={entityIds[0]} creation={creation} setCreation={setCreation} />
      );
    case "buyer":
      return <SaveToBuyerList buyerIds={entityIds} creation={creation} setCreation={setCreation} />;
    case "supplier":
      return (
        <SaveToCompetitorOrPartner
          supplierGuids={entityIds}
          creation={creation}
          setCreation={setCreation}
        />
      );
    default:
      return null;
  }
}
